/*
 * @format
 */

import React from 'react';

import Topic from './Topic';
import WatchZoneDiagram from './WatchZoneDiagram';

const zoneScreenBody =
  'The watch zone screen acts as your home screen. Here you can see ' +
  'information about your heating zone including target and current ' +
  'temperature along with heating mode.';

function WatchAppHelpZoneScreen() {
  return (
    <Topic
      title="Zone screen"
      body={zoneScreenBody}
      diagram={<WatchZoneDiagram />}
    />
  );
}

export default WatchAppHelpZoneScreen;
